/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ClassCalendarItem
 */
export interface ClassCalendarItem {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ClassCalendarItem
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof ClassCalendarItem
     */
    className: string;
    /**
     * 
     * @type {string}
     * @memberof ClassCalendarItem
     */
    locationName: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassCalendarItem
     */
    classRoomName: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassCalendarItem
     */
    teacherNames: Array<string>;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ClassCalendarItem
     */
    enrollmentCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ClassCalendarItem
     */
    maxNumberOfStudents: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {Date}
     * @memberof ClassCalendarItem
     */
    date: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClassCalendarItem
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClassCalendarItem
     */
    endTime: Date;
}

/**
 * Check if a given object implements the ClassCalendarItem interface.
 */
export function instanceOfClassCalendarItem(value: object): value is ClassCalendarItem {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('className' in value) || value['className'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('classRoomName' in value) || value['classRoomName'] === undefined) return false;
    if (!('teacherNames' in value) || value['teacherNames'] === undefined) return false;
    if (!('enrollmentCount' in value) || value['enrollmentCount'] === undefined) return false;
    if (!('maxNumberOfStudents' in value) || value['maxNumberOfStudents'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function ClassCalendarItemFromJSON(json: any): ClassCalendarItem {
    return ClassCalendarItemFromJSONTyped(json, false);
}

export function ClassCalendarItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassCalendarItem {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'className': json['className'],
        'locationName': json['locationName'],
        'classRoomName': json['classRoomName'],
        'teacherNames': json['teacherNames'],
        'enrollmentCount': ApiUserTasksGetPageParameterFromJSON(json['enrollmentCount']),
        'maxNumberOfStudents': ActorActivityRecordActorUserIdFromJSON(json['maxNumberOfStudents']),
        'date': (new Date(json['date'])),
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
    };
}

export function ClassCalendarItemToJSON(json: any): ClassCalendarItem {
    return ClassCalendarItemToJSONTyped(json, false);
}

export function ClassCalendarItemToJSONTyped(value?: ClassCalendarItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'className': value['className'],
        'locationName': value['locationName'],
        'classRoomName': value['classRoomName'],
        'teacherNames': value['teacherNames'],
        'enrollmentCount': ApiUserTasksGetPageParameterToJSON(value['enrollmentCount']),
        'maxNumberOfStudents': ActorActivityRecordActorUserIdToJSON(value['maxNumberOfStudents']),
        'date': value['date'].toISOString().substring(0,10),
        'startTime': value['startTime'].toISOString(),
        'endTime': value['endTime'].toISOString(),
    };
}

